import React from 'react';
import { useMediaQuery, styled } from '@mui/material';
import { Colors } from 'library';
import { Title, Text, Stack } from 'library/ui';
import theme from 'theme';
import { isToday } from 'date-fns';
import Holiday from './Holiday';
import { formatDateFromDateObject } from 'shared/Dates';
import CoveredShift from './CoveredShift';
export default function CalendarHeader({
    d,
    start,
    end,
    holidays,
    coveredShifts,
}: {
    d: Date;
    start: Date;
    end: Date;
    holidays: { name: string; date: string }[];
    coveredShifts: { shift_count: number; date: string }[];
}) {
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    return (
        <>
            <HeaderBar
                className="calendar-day-header"
                d={d}
                start={start}
                end={end}
                mdDown={mdDown}
                align="center"
                gap="sm"
                justify="center"
            >
                <Title size="h1" tone="inherit">
                    {d.toLocaleDateString('en-US', { day: 'numeric' })}
                </Title>
                <Text size="xs" tone="secondary">
                    {d.toLocaleDateString('en-US', {
                        weekday: 'short',
                        day: 'numeric',
                        month: 'short',
                    })}
                </Text>
            </HeaderBar>
            <Holiday holidays={holidays.filter((day) => day.date === formatDateFromDateObject(d))} />
            <CoveredShift coveredShifts={coveredShifts.filter((day) => day.date === formatDateFromDateObject(d))} />
        </>
    );
}

const HeaderBar = styled(Stack)(({ d, start, end, mdDown }: { d: Date; start: Date; end: Date; mdDown: boolean }) => ({
    height: 75,
    color: Colors.textSecondary,
    backgroundColor: isToday(d) ? Colors.secondarySoft : Colors.white,
    borderTopRightRadius: d.getDay() === end.getDay() || mdDown ? 18 : 0,
    borderTopLeftRadius: d.getDay() === start.getDay() || mdDown ? 18 : 0,
    borderBottom: isToday(d) ? `3px solid ${Colors.secondary}` : `1px solid ${Colors.border}`,
}));
